import React, { useMemo } from 'react';
import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';
const Providers = ({ children, config, }) => {
    const tpa = useMemo(() => ({
        mobile: config.isMobile,
        rtl: config.isRTL,
    }), [config.isMobile, config.isRTL]);
    return React.createElement(TPAComponentsProvider, { value: tpa }, children);
};
export default Providers;
//# sourceMappingURL=providers.js.map